import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.dokument-hinzufuegen';
import * as api from '../../../clients/vorlagen';

@Injectable()
export class VorlagenDokumentHinzufuegenEffects {

    DokumentHinzufuegen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_DOKUMENT_HINZUFUEGEN),
        mergeMap((x: ac.PostDokumentHinzufuegenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postDokumentHinzufuegen(x.dokumentHinzufuegenRequest).pipe(
                map((result: any) => {
                    return new ac.PostDokumentHinzufuegenErfolgreichAction(result, x.dokumentHinzufuegenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostDokumentHinzufuegenFehlerAction(error, x.dokumentHinzufuegenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DokumentCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DokumentCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.DokumentCommandService);
        }
        return this.service;
    }
}
